import * as t from './actionTypes';
import { errorText } from '../../../shared/lib/reducer-util';

const initialState = {
  initialLoad: true,
  loading: false,
  loaded: false,
  airport: null,
  center: null,
  region: 'northAmerica',
  zoom: null,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case t.START_SPINNER:
      return {
        ...state,
        loading: true,
      };
    case t.END_SPINNER:
      return {
        ...state,
        loading: false,
      };
    case t.LOAD_DETAILS_BY_CODE:
      return {
        ...state,
        error: null,
      };
    case t.LOAD_DETAILS_SUCCESS:
      return {
        ...state,
        error: null,
        loaded: true,
        data: action.result,
      };

    case t.LOAD_DELAY_INDICES:
      return {
        ...state,
        error: null,
        // data: null,
        list: null,
        basicInfo: null,
      };
    case t.LOAD_DELAY_INDICES_SUCCESS:
      return {
        ...state,
        error: null,
        loaded: true,
        delayIndices: action.delayIndices,
        delayObj: action.delayObj,
        defaultAirports: action.defaultAirports,
      };

    case t.LOAD_FAIL:
      return {
        ...state,
        loaded: false,
        error: errorText(action.error),
      };
    case t.SET_AIRPORT:
      return {
        ...state,
        airport: action.airport,
      };
    case t.SET_REGION:
      return {
        ...state,
        region: action.region,
      };
    case t.UPDATE_MAP:
      return {
        ...state,
        center: action.center,
        zoom: action.zoom,
      };
    case t.UPDATE_REGION:
      return {
        ...state,
        region: action.region,
        airport: action.airport,
        center: null,
        zoom: null,
      };
    case t.INITIAL_LOAD_FINISH:
      return {
        ...state,
        initialLoad: false,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./modules/AirportDelayMap/redux/reducer.js